
import * as actions from '../actions'
import { compose } from 'redux'
import { connect } from 'react-redux'
const mapStateToProps = ({  }) => {
  return {};
};

export default compose(
  connect(mapStateToProps, {
    showError: actions.showError,
    showSuccess: actions.showSuccess,
    dismissNotification: actions.dismissNotification
  }),
);


// WEBPACK FOOTER //
// ./src/modules/notification/components/withNotifications.js